import React from 'react'
import { Button, Colors } from 'react-foundation'
import CopyToClipboard from 'react-copy-to-clipboard'

require('../style/css/third_party/foundation.css')
require('../style/css/third_party/animate.css')

require('../style/scss/custom/main.scss')

require('../style/css/custom/components/aboutMe.css')
require('../style/css/custom/components/aboutMe_more.css')
require('../style/css/custom/main.css')

require('../js_animations/customAnimations.js')
require('../js_animations/scrollMagic.js')


const AboutMe_more = ({
  myEmail,
  myPhone,
  logo_white_PNG,
  logo_blue_PNG_960,
  logo_blue_PNG_100,
  logo_blue_PNG_70,
  logo_blue_PNG_16,

  copiedMessageClass_1,
  contactMeToggle,

  onCopy,
  contactButtonHover_ON_thisWebsite,
  contactButtonHover_OFF_thisWebsite,
  contactButtonClicked_thisWebsite

}) => (

<div id="about_more">

  {
  // MORE ABOUT ME
  }
  {
  // Header
  }
  <div className="about_me__text_header">
    <p className="wow bounceInUp " data-wow-offset="0">M</p><p className="wow bounceInUp " data-wow-offset="60">O</p><p className="wow bounceInUp " data-wow-offset="70">R</p><p className="wow bounceInUp " data-wow-offset="80">E</p> <p className="wow bounceInUp " data-wow-offset="90">A</p><p className="wow bounceInUp  " data-wow-offset="100">B</p><p className="wow bounceInUp  " data-wow-offset="110">O</p><p className="wow bounceInUp  " data-wow-offset="120">U</p><p className="wow bounceInUp  " data-wow-offset="130">T</p> <p className="wow bounceInUp  " data-wow-offset="150">M</p><p className="wow bounceInUp  " data-wow-offset="160">E</p>
  </div>
  {
  // Description and Button
  }
  <div className="description_4 opacity1 wow fadeIn" data-wow-offset="125" id="more_about_me_description">
    <p className="p_more">
      When I’m not coding, I enjoy making music in my home studio, hanging out with my cat, and going on long walks by the coast.  Also, I am obsessed with classical music and outer space.
    </p>
    {
    // <Button color={Colors.PRIMARY} isHollow className="links__more">
    //   <a href="https://www.entrzelle.com">CHECK OUT MY MUSIC</a>
    // </Button>
    }

  <div className="buttons_container">
    <div id='copiedMessage_thisWebsite'>
      <span className={copiedMessageClass_1}>copied!</span>
    </div>
    <CopyToClipboard text={myEmail} onCopy={onCopy}>
      <Button color={Colors.SUCCESS} isHollow className="description__contact_button wow fadeIn" data-wow-offset="90" onMouseEnter={contactButtonHover_ON_thisWebsite} onMouseLeave={contactButtonHover_OFF_thisWebsite} onClick={contactButtonClicked_thisWebsite} >{contactMeToggle}</Button>
    </CopyToClipboard>
  </div>


  </div>




</div>

)

export default AboutMe_more



// WEBPACK FOOTER //
// ./src/components/aboutMe_more.js